import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';
import Text from '../text';
import styles from './header-switch.styles';
import { Tab, Tabs } from '@dbk/ui-tabs';

class HeaderSwitch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      timeline: 0,
    };
    this.onSelectTab = this.onSelectTab.bind(this);
  }

  componentDidUpdate(prevState){
    if (this.state.timeline !== prevState.timeline) {
      this.setState({ timeline: this.state.timeline });
    }
  }
  static propTypes = {
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string.isRequired,
    })),
    selected: PropTypes.string,
    onChange: PropTypes.func,
  }

  onSelectTab(options) {
    this.setState({ timeline: options });
    var tabFrom = 'deposits';
    if (options === 1){
      tabFrom = 'funds';
    }
    this.props.onChange(tabFrom);
  }

  renderSwitchElement() {
    const { options, messages } = this.props;

    if (typeof options === 'undefined' || options.length === 0) {
      return <Text style={styles.loading}>{messages['app.common.loadingText']}</Text>;
    }
    let mmins = messages[options[0].label];
    if (options.length === 1) {
      return (
        <View style={styles.positionType}>
          <Text style={styles.positionTypeText}>{mmins}</Text>
        </View>
      );
    }

    return (
      <View style={{ flex: 1 }}>
        <Tabs
          secondary
          handleSelectedIndex={this.onSelectTab}
          selectedIndex={this.state.timeline}
          stretch>
          <Tab renderLabel={() => messages['app.common.portfolio.mmins']} />
          <Tab renderLabel={() => messages['app.common.portfolio.mmFunds']} />
        </Tabs>
      </View>
    );
  }

  render() {
    return (
      <View style={styles.container}>
        {this.renderSwitchElement()}
      </View>
    );
  }
}

export default HeaderSwitch;
